// 印尼单一货币下的文案：钻石、Nicee 幣都改叫 Koin（繁中「金幣」、简中「金币」、英文 Coins）。
// 是否单一货币在构建时由 vue.config.js 按后端地址写进 VUE_APP_SINGLE_COIN。
export const isSingleCoin = process.env.VUE_APP_SINGLE_COIN === 'true';

// 不是货币的「钻石」：游戏段位、会员等级、宝箱名；台湾活动文案（印尼不开）；
// VIP 举例里写死了台湾的换算数字，单纯换词会算错
const SKIP_KEY_PATTERNS = [
  /^game\w*_diamond$/,
  /^diamond_member$/,
  /^diamond_chest_/,
  /^luck_party_/,
  /^palyer_panel_/,
  /^score3_explain_popup_tip18$/
];

const RULES = {
  tw: [[/nicee ?幣/gi, '金幣'], [/[鑽钻鉆]石/g, '金幣'], [/[鑽钻鉆]/g, '金幣']],
  cn: [[/nicee ?[幣币]/gi, '金币'], [/[鑽钻鉆]石/g, '金币'], [/[鑽钻鉆]/g, '金币']],
  // 英文界面原本就叫 Coins，钻石跟着叫 Coins / Coin
  en: [
    [/nicee coins/gi, 'Coins'],
    [/nicee coin/gi, 'Coin'],
    [/Diamonds/g, 'Coins'],
    [/diamonds/g, 'coins'],
    [/Diamond/g, 'Coin'],
    [/diamond/g, 'coin']
  ],
  idn: [
    [/koin nicee|nicee koin|nicee coins?/gi, 'Koin'],
    [/berlian|permata|diamonds?|diamon/gi, 'Koin']
  ]
};

// {msg}、{amount} 这类插值原样保留，只改普通文字
const PLACEHOLDER = /(\{[^}]*\})/;

function rewriteText(text, rules) {
  return text
    .split(PLACEHOLDER)
    .map((part, i) =>
      i % 2 === 1
        ? part
        : rules.reduce((acc, [pattern, repl]) => acc.replace(pattern, repl), part)
    )
    .join('');
}

function isSkipped(key) {
  return SKIP_KEY_PATTERNS.some(pattern => pattern.test(key));
}

function rewriteValue(key, value, rules) {
  if (typeof value === 'string') {
    return isSkipped(key) ? value : rewriteText(value, rules);
  }
  if (Array.isArray(value)) {
    return value.map(item => rewriteValue(key, item, rules));
  }
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce(
      (acc, child) => ({ ...acc, [child]: rewriteValue(child, value[child], rules) }),
      {}
    );
  }
  return value;
}

/** 返回新的文案对象（不改原对象）；没有规则的语言原样返回 */
export function currencyMessages(messages) {
  return Object.keys(messages).reduce((acc, lang) => {
    const rules = RULES[lang];
    return { ...acc, [lang]: rules ? rewriteValue('', messages[lang], rules) : messages[lang] };
  }, {});
}
